import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import NavBar from "../NavBar/index";
import { PrivateRoutes } from "../../routes/PrivateRoutes";
import PrivateRoutesConfig from "../../config/PrivateRoutesConfig";
import Footer from "../Footer/index";

const Layout = () => {
  return (
    <Router className>
      <NavBar />
      <main className="bg-white">
        <div className="mx-10 py-6 sm:px-6 lg:px-8">
          <Switch>
            <PrivateRoutes allowedRoutes={PrivateRoutesConfig} />
          </Switch>
        </div>
      </main>
      <Footer />
    </Router>
  );
};

export default Layout;
